// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_pay_not_found_token = /** @type {(inputs: {}) => string} */ () => {
	return `Invalid Token Contract Address, Unable to Top Up`
};

const id_pay_not_found_token = /** @type {(inputs: {}) => string} */ () => {
	return `Alamat Kontrak Token Tidak Valid, Tidak Bisa Isi Ulang`
};

const de_pay_not_found_token = /** @type {(inputs: {}) => string} */ () => {
	return `Ungültige Token-Vertragsadresse, Aufladen nicht möglich`
};

const fr_pay_not_found_token = /** @type {(inputs: {}) => string} */ () => {
	return `Adresse de contrat de jeton non valide, impossible de recharger`
};

const es_pay_not_found_token = /** @type {(inputs: {}) => string} */ () => {
	return `Dirección de contrato de token no válida, no se puede recargar`
};

const ru_pay_not_found_token = /** @type {(inputs: {}) => string} */ () => {
	return `Неверный адрес контракта токена, невозможно пополнить`
};

const zh_pay_not_found_token = /** @type {(inputs: {}) => string} */ () => {
	return `Token合约地址无效，无法充值`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "de" | "fr" | "es" | "ru" | "zh" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pay_not_found_token = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pay_not_found_token(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("pay_not_found_token", locale)
	if (locale === "en") return en_pay_not_found_token(inputs)
	if (locale === "id") return id_pay_not_found_token(inputs)
	if (locale === "de") return de_pay_not_found_token(inputs)
	if (locale === "fr") return fr_pay_not_found_token(inputs)
	if (locale === "es") return es_pay_not_found_token(inputs)
	if (locale === "ru") return ru_pay_not_found_token(inputs)
	if (locale === "zh") return zh_pay_not_found_token(inputs)
	return "pay_not_found_token"
};